import axios from "axios";
import { BASE_URL } from "../misc/Static_routes";
import { toast } from "react-toastify";
import axiosInstance from "../config/axiosConfig";
import { serverMessage } from "./serverMessage";
axios.defaults.withCredentials = true;

// REFACTOR: This need to be changed
const notify = (message) => toast.error(`${message}`, {});
const notifySuccess = (message) => toast.success(`${message}`, {});
const notifyError = (message) => toast.error(`${message}`, {});

export const getDesignByPinId = (pinId) => {
  return axios
    .get(`${BASE_URL}/api/pin/${pinId}/designs`)
    .then((response) => {
      if (response?.status === 200) {
        return response.data; // always return data if status 200
      }
      throw new Error(
        `Unexpected response: ${response.status} ${response.statusText}`
      );
    })
    .catch((error) => {
      console.error("getDesignByPinId error:", error);
      return null; // return null instead of undefined
    });
};

export const getDesignByPinIdInRange = (data) => {
  const result = axios
    .get(
      `${BASE_URL}/api/pin/${data.pinID}/designs/${data.offset}/${data.limit}`
    )
    .then((response) => {
      const responseOK =
        response && response.status === 200;

      if (responseOK) {
        return response.data;
      }
    })
    .catch((error) => {
      console.log("error", error);
    });

  return result;
};

export const getDesignById = (pinId, designId) => {
  return axios
    .get(`${BASE_URL}/api/pin/${pinId}/design/${designId}`)
    .then((response) => {
      if (response?.status === 200) {
        return response.data; // always return data if status is OK
      }
      throw new Error(
        `Unexpected response: ${response.status} ${response.statusText}`
      );
    })
    .catch((error) => {
      console.error("getDesignById error:", error);
      return null; // avoid returning undefined
    });
};

export const createDesign = async (data, t) => {
  const result = axios
    .post(`${BASE_URL}/api/pin/${data.pin_id}/designs`, data)
    .then((response) => {
      const responseOK =
        response && response.status === 200;
      if (responseOK) {
        notifySuccess(t("designCreated"));
        return response.data;
      } else {
        notifyError(t("errorWhileCreatingDesign"));
      }

      return result;
    });
};

export const deleteDesign = async (data) => {
  const result = axios
    .delete(`${BASE_URL}/api/designs`, { data })
    .then((response) => {
      const responseOK =
        response && response.status === 200;
      if (responseOK) {
        notifySuccess(serverMessage(response?.data));
        return response.data;
      }
    })
    .catch((err) => {
      notify(serverMessage(err?.response?.data));
    });

  return result;
};

export const designService = {
  getDesignByPinIdInRange: (url) => axiosInstance.get(url),
};
